import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import ListView from 'bstrap-react-mobx-admin/view/list'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import { DropdownButton, MenuItem } from 'react-bootstrap'

const TestingListView = ({ store }) => {
  if (!store.hasRight(linkConst.LINK_FPVTESTING)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const fields = [
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => {
      const DetailLink = ({ text }) => (
        <a href='javascript:void(0)' onClick={() => store.detailClicked(row)}>{text}</a>
      )
      return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
    },
    (attr, row) => (<OptionsField
      attr={attr}
      val={row[attr]}
      options={store.options.get('TestingGroups')}
      labelattr='text'
      valueattr='value' />),
    (attr, row) => (<OptionsField
      attr={attr}
      val={row[attr]}
      options={store.options.get('FlyPrivatePlatformsAuth0')}
      labelattr='text'
      valueattr='value' />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />)
  ]

  const batchActions = () => {
    return (
      <DropdownButton className={defaultConst.ACTION_BUTTON_CLASS1} title={store.__(defaultConst.TITLE_BATCH_ACTIONS)} pullRight id='listactions-dropdown'>
        <MenuItem key={linkConst.BATCH_ACTION_TESTING1} eventKey={linkConst.BATCH_ACTION_TESTING1}
          onClick={store.gotoBatch.bind(store, linkConst.BATCH_ACTION_TESTING1)}>
          <span className={linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING1].icon} />&nbsp;
          {store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING1].title)}
        </MenuItem>
        <MenuItem key={linkConst.BATCH_ACTION_TESTING2} eventKey={linkConst.BATCH_ACTION_TESTING2}
          onClick={store.gotoBatch.bind(store, linkConst.BATCH_ACTION_TESTING2)}>
          <span className={linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING2].icon} />&nbsp;
          {store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING2].title)}
        </MenuItem>
        <MenuItem key={linkConst.BATCH_ACTION_TESTING3} eventKey={linkConst.BATCH_ACTION_TESTING3}
          onClick={store.gotoBatch.bind(store, linkConst.BATCH_ACTION_TESTING3)}>
          <span className={linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING3].icon} />&nbsp;
          {store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING3].title)}
        </MenuItem>
        <MenuItem key={linkConst.BATCH_ACTION_SETGROUP} eventKey={linkConst.BATCH_ACTION_SETGROUP}
          onClick={store.gotoBatch.bind(store, linkConst.BATCH_ACTION_SETGROUP)}>
          <span className={linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_SETGROUP].icon} />&nbsp;
          {store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_SETGROUP].title)}
        </MenuItem>
        <MenuItem divider />
        <MenuItem key={'delete'} eventKey={'delete'} onClick={store.batchDelete.bind(store)}>
          <span className='glyphicon glyphicon-remove' />&nbsp;
          {store.__(defaultConst.TITLE_DELETE)}
        </MenuItem>
      </DropdownButton>
    )
  }

  const filters = {
    id_like: {
      title: 'ID',
      component: (props) => (<TextInput {...props} />)
    },
    tester_id_like: {
      title: 'auth0 ID',
      component: (props) => (<TextInput {...props} />)
    },
    tester_group_like: {
      title: 'Tester group',
      component: (props) => (<SelectInput {...props}
        optionsrecord={store.options}
        labelattr='text'
        valueattr='value'
        optionsattr={'TestingGroups'} />)
    },
    platform_auth0: {
      title: 'platform',
      component: (props) => (<SelectInput {...props}
        optionsrecord={store.options}
        labelattr='text'
        valueattr='value'
        optionsattr={'FlyPrivatePlatformsAuth0'} />)
    },
    tester_email_like: {
      title: 'e-mail',
      component: (props) => (<TextInput {...props} />)
    },
    tester_name_like: {
      title: 'name',
      component: (props) => (<TextInput {...props} />)
    }
  }

  return (
    <ListView store={store.cv} fields={fields} filters={filters}
      onAddClicked={store.addClicked.bind(store)} helper={store.helpFor(linkConst.LINK_FPVTESTING)}
      batchActions={batchActions} />
  )
}
export default observer(TestingListView)
